import Hammer from 'hammerjs'

up.compiler('.js-switch_with_labels', function (wrapper) {
  const leftInput = wrapper.querySelector('.js-switch_with_labels__input--left')
  const leftLabel = wrapper.querySelector('.js-switch_with_labels__input--left + label') || leftInput.parentElement
  const rightInput = wrapper.querySelector('.js-switch_with_labels__input--right')
  const rightLabel = wrapper.querySelector('.js-switch_with_labels__input--right + label') || rightInput.parentElement

  const toggleButton = wrapper.querySelector('.js-switch_with_labels__toggle')
  const hammer = new Hammer(toggleButton)

  function toggle() {
    if (leftInput.checked) {
      rightInput.click()
    } else {
      leftInput.click()
    }

    stopHoverUnselectedInput()
  }

  function startHoverUnselectedInput() {
    let el

    if (leftInput.checked) {
      el = rightInput
    } else {
      el = leftInput
    }

    el.classList.add('switch_with_labels__input--hover')
  }

  function stopHoverUnselectedInput() {
    let el

    if (leftInput.classList.contains('switch_with_labels__input--hover')) {
      el = leftInput
    } else {
      el = rightInput
    }

    el.classList.remove('switch_with_labels__input--hover')
  }

  function getStartHoverToggle(el) {
    return function () {
      if (!el.checked) {
        toggleButton.classList.add('switch_with_labels__toggle--hover')
      }
    }
  }

  function stopHoverToggle() {
    toggleButton.classList.remove('switch_with_labels__toggle--hover')
  }

  if (toggleButton.disabled) {
    wrapper.classList.add('switch_with_labels--disabled')
  } else {
    toggleButton.addEventListener('click', toggle)
    rightLabel.addEventListener('click', stopHoverToggle)
    leftLabel.addEventListener('click', stopHoverToggle)

    toggleButton.addEventListener('mouseover', startHoverUnselectedInput)
    toggleButton.addEventListener('mouseout', stopHoverUnselectedInput)
    rightLabel.addEventListener('mouseover', getStartHoverToggle(rightInput))
    rightLabel.addEventListener('mouseout', stopHoverToggle)
    leftLabel.addEventListener('mouseover', getStartHoverToggle(leftInput))
    leftLabel.addEventListener('mouseout', stopHoverToggle)

    hammer.on('swipe', function (e) {
      toggle()
    })
  }

  return () => {
    hammer.destroy()
  }
})
